import {Component, Input, OnDestroy, OnInit, ChangeDetectorRef} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {Stop} from '../../shared/models/stop.model';
import {FormControl, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {takeUntil} from 'rxjs/operators';
import {UserService} from '../../shared/services/user.service';
import {DataStorageService} from "../../shared/services/data-storage.service";
import {Dispatch} from "../../shared/models/dispatch.model";
import {ActivatedRoute} from '@angular/router';
import {CalendarService} from "../../shared/services/calendar.service";
import {UserLogin} from '../../shared/models/user.model';

@Component({
    selector: 'form-calendar',
    templateUrl: 'form-calendar.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormCalendarComponent implements OnInit, OnDestroy {
    constructor(
        private router: Router,
        private routeService: RouteService,
        private userService: UserService,
        private dataStorageService: DataStorageService,
        private route: ActivatedRoute,
        private calendarService: CalendarService,
        private cdr: ChangeDetectorRef) {
    }

    @Input() y: number;
    @Input() m: number;
    @Input() user: UserLogin;

    calendarForm: FormGroup;
    dispatches: Dispatch[];
    stops: Stop[];

    mOptions: any = [];
    yOptions: any = [];
    stopOptions: any = [];
    agencyOptions: any = [];
    public navigation: any;
    selectedAgencyLabel: any = [];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    ySelectValue: number;
    mSelectValue: number;
    stopSelectValue: string[] = [''];
    agencySelectValue: string[] = [''];

    date: { year: number, month: number };

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {


        this.ySelectValue = +this.y;
        this.mSelectValue = +this.m;

        this.initYearOptions();
        this.initMonthOptions();

        this.stops = this.routeService.getStop();
        this.initStopOptions();
        this.initForm();

        this.calendarForm.get('agency').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((agencyId) => {


                // agencyId에 해당하는 label 찾아서 저장
                const selected = this.agencyOptions.find(opt => opt.value === agencyId);
                this.cdr.detectChanges();
                console.log('Agency changed:', selected);

            });


        this.routeService.stopsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (stops: Stop[]) => {
                this.stops = this.routeService.getStop();
                this.initStopOptions();
            }
        );
        this.route.queryParams.subscribe(params => {
            const agencyId = params['user_id'];
            const selectedAgency = this.agencyOptions.find(opt => opt.value === agencyId);
            if (agencyId) {
                const agency = selectedAgency.label;

                console.log('Label for agencyId', agencyId, ':', agency);
            }
        });
        this.initAgencyOptions();

    }

    initForm() {
        this.calendarForm = new FormGroup({
            'year': new FormControl(),
            'month': new FormControl(),
            'agency': new FormControl(this.selectedAgencyLabel),
            'stop': new FormControl()
        });
    }

    initAgencyOptions() {
        const users = this.userService.getUser();
        users.sort((a, b) => (a.user_name.toUpperCase() < b.user_name.toUpperCase() ? -1 : 1));
        for (const user of users) {
            this.agencyOptions.push({'label': user.user_name, 'value': user.id, 'code': user.user_name});
        }
    }

    initYearOptions() {
        const prevYear = +this.y - 1;
        const nextYear = +this.y + 1;
        for (let i = prevYear; i <= nextYear; i++) {
            this.yOptions.push({'label': i, 'value': i, 'code': i});
        }
    }

    initMonthOptions() {
        const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        for (const key in month) {
            this.mOptions.push({'label': month[key], 'value': +key + 1, 'code': key + 1});
        }
    }

    initStopOptions() {
        for (const stop of this.stops) {
            this.stopOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }
    }


    onNavigateCalendar(): void {
        const value = this.calendarForm.value;
        const year = value.year;
        const month = value.month;
        const agency = value.agency;

        this.router.navigate(
            ['/apps/calendars', year, month],
            {queryParams: agency ? {user_id: agency} : {}}
        );
    }


    /*
        onNavigateCalendar() {
            const value = this.calendarForm.value;
            console.log('here' + value.agency);
            this.router.navigate(['/apps/calendars/' + value.year + '/' + value.month]);
        }
    */

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
